import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ItkTokenManagementServiceLegacy } from '@itk/ng-auth';
import { ITK_NG_DJANGO_API_CLIENT } from '@itk/ng-django-api';
import { ItkDjangoApi } from '@itk/universal-django-api';
import { Observable, catchError, map, of, tap } from 'rxjs';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(
    private readonly token: ItkTokenManagementServiceLegacy,
    private readonly router: Router,
    @Inject(PLATFORM_ID) private readonly pid: string,
    @Inject(ITK_NG_DJANGO_API_CLIENT) private readonly api: ItkDjangoApi,
  ) {}

  canActivate(): Observable<boolean> {
    if (!this.token.isValidToken(this.token.getAccessToken())) {
      if (isPlatformBrowser(this.pid)) {
        void this.router.navigateByUrl('/logout');
      }

      return of(false);
    }

    return this.api.member.getMember().pipe(
      map((x) => !('error' in x)),
      tap((x) => {
        if (!x && isPlatformBrowser(this.pid)) {
          void this.router.navigateByUrl('/logout');
        }
      }),
      catchError(() => of(false)),
    );
  }
}
